var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.$.select, _vm.$.sort_by] },
    [
      _vm.isBoardConfigLoading
        ? [
            _c("skeleton-item", {
              style: { height: "24px", width: "116px", marginRight: 0 },
              attrs: { type: "bar" },
            }),
          ]
        : [
            _vm.canRefresh
              ? _c("icon-button", {
                  class: _vm.$.sort_refresh,
                  attrs: {
                    icon: { name: "update", size: 20 },
                    colors: _vm.iconButtonColors,
                    active: true,
                  },
                  on: { onClick: _vm.refreshSort },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  _vm.$.picker,
                  _vm.canRefresh ? _vm.$.can_refresh : "",
                  _vm.isContextOpened || _vm.canRefresh ? _vm.$.active : "",
                ],
                on: { click: _vm.toggleContextMenu },
              },
              [
                _c("div", { class: _vm.$.label }, [
                  _vm._v("\n        " + _vm._s(_vm.label) + "\n      "),
                ]),
                _vm._v(" "),
                _c("div", { class: _vm.$.active }, [
                  _vm._v("\n        " + _vm._s(_vm.sortName) + "\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isClearButton,
                        expression: "isClearButton",
                      },
                    ],
                    class: [_vm.$.clear_icon, "toggle_ignore"],
                    on: {
                      click: _vm.clearSort,
                      mouseenter: function ($event) {
                        _vm.closeButtonType = "bold"
                      },
                      mouseleave: function ($event) {
                        _vm.closeButtonType = "regular"
                      },
                    },
                  },
                  [
                    _c("svg-sprite", {
                      attrs: {
                        name: "close-5",
                        type: _vm.closeButtonType,
                        size: 20,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isClearButton,
                        expression: "!isClearButton",
                      },
                    ],
                    class: _vm.$.side_icon,
                  },
                  [
                    _c("svg-sprite", {
                      attrs: {
                        name: _vm.isContextOpened ? "arrow-top" : "arrow-down",
                        type: "regular",
                        size: 20,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
      _vm._v(" "),
      _vm.sortName
        ? _c(
            "div",
            { class: _vm.$.sort_icon, on: { click: _vm.changeDirection } },
            [
              _c("icon-button", {
                attrs: {
                  icon: {
                    name: _vm.direction === "ASC" ? "priority" : "priority-2",
                    size: 20,
                  },
                  colors: _vm.iconButtonColors,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }